var _defs, _path, _path2, _path3, _path4, _ellipse, _ellipse2, _ellipse3, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthInsuranceContributionsOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_9f193f72c7f1213a88012b88c46773c2a55484c6b564a757527204060e413791",
    x1: 85.81,
    y1: 122.95,
    x2: 146.51,
    y2: 122.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a0399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b10372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_9f193f72c7f1213a88012b88c46773c2a55484c6b564a757527204060e413791",
    "data-name": "C_BG_shellbar",
    x1: 75.15,
    y1: 27.98,
    x2: 117.41,
    y2: 27.98,
    xlinkHref: "#SVGID_0_9f193f72c7f1213a88012b88c46773c2a55484c6b564a757527204060e413791"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_9f193f72c7f1213a88012b88c46773c2a55484c6b564a757527204060e413791",
    "data-name": "C_BG_shellbar",
    x1: 76.15,
    y1: 40.98,
    x2: 118.41,
    y2: 40.98,
    gradientTransform: "translate(-1 -13)",
    xlinkHref: "#SVGID_0_9f193f72c7f1213a88012b88c46773c2a55484c6b564a757527204060e413791"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_9f193f72c7f1213a88012b88c46773c2a55484c6b564a757527204060e413791",
    "data-name": "C_BG_shellbar",
    x1: 84.72,
    y1: 69.98,
    x2: 109.29,
    y2: 69.98,
    xlinkHref: "#SVGID_0_9f193f72c7f1213a88012b88c46773c2a55484c6b564a757527204060e413791"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_9f193f72c7f1213a88012b88c46773c2a55484c6b564a757527204060e413791",
    "data-name": "C_BG_shellbar",
    x1: 90.81,
    y1: 120.59,
    x2: 143.19,
    y2: 120.59,
    xlinkHref: "#SVGID_0_9f193f72c7f1213a88012b88c46773c2a55484c6b564a757527204060e413791"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M98.03 131.85H61.71c-2.31 0-4.19-2.08-4.19-4.64V30.55c0-2.56 1.88-4.64 4.19-4.64h15.51M115.26 25.91h15.59c2.31 0 4.19 2.08 4.19 4.64v65.91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_1_9f193f72c7f1213a88012b88c46773c2a55484c6b564a757527204060e413791)",
    d: "M112.25 33.61l4.06-11.27H76.25l4.06 11.27h31.94z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_2_9f193f72c7f1213a88012b88c46773c2a55484c6b564a757527204060e413791)",
    d: "M112.25 33.61l4.06-11.27H76.25l4.06 11.27h31.94z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M107.01 69.52a8.18 8.18 0 017.57-5.08c3.86 0 7.09 2.68 7.95 6.28M70.03 70.84c.81-3.66 4.07-6.4 7.98-6.4 4.23 0 7.7 3.21 8.13 7.33"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "MI_4L_main",
    cx: 114.78,
    cy: 59.78,
    rx: 4.75,
    ry: 4.67
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "MI_4L_main",
    cx: 97.18,
    cy: 57.41,
    rx: 6.71,
    ry: 6.6
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "MI_4L_main",
    cx: 78.02,
    cy: 59.78,
    rx: 4.75,
    ry: 4.67
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M85.16 75.36C85.73 69.32 90.82 64.6 97 64.6s11.22 4.68 11.83 10.67",
    stroke: "url(#SVGID_3_9f193f72c7f1213a88012b88c46773c2a55484c6b564a757527204060e413791)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M85.16 75.36C85.73 69.32 90.82 64.6 97 64.6s11.22 4.68 11.83 10.67"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M140.27 125.44l-24.1 24.11-24.11-24.11c-6.66-6.66-6.66-17.45 0-24.1 6.66-6.66 17.45-6.66 24.11 0 6.66-6.66 17.44-6.66 24.1 0 6.66 6.65 6.66 17.45 0 24.1z",
    stroke: "url(#SVGID_0_9f193f72c7f1213a88012b88c46773c2a55484c6b564a757527204060e413791)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_4_9f193f72c7f1213a88012b88c46773c2a55484c6b564a757527204060e413791)",
    d: "M92.05 124.91l12.93.21 6-16.23 8.25 23.41 3.63-9.39 19.08.28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthInsuranceContributionsOverview);
export default __webpack_public_path__ + "static/media/healthInsuranceContributionsOverview.6d188adf7d9a004c352cc0526f5a6672.svg";
export { ForwardRef as ReactComponent };